// extracted by mini-css-extract-plugin
export default {"linksSection":"MH-z"};